import { render, staticRenderFns } from "./SearchSidebarContent.vue?vue&type=template&id=2531c036&scoped=true&"
import script from "./SearchSidebarContent.vue?vue&type=script&lang=js&"
export * from "./SearchSidebarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2531c036",
  null
  
)

export default component.exports